export default __webpack_public_path__ + "static/media/airDrops.f5f82555.png";